import { render } from "./ProductLayOut.vue?vue&type=template&id=2bbe654a&scoped=true"
import script from "./ProductLayOut.vue?vue&type=script&lang=js"
export * from "./ProductLayOut.vue?vue&type=script&lang=js"

import "./ProductLayOut.vue?vue&type=style&index=0&id=2bbe654a&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbe654a"]])

export default __exports__